import a from './a';
import heading from './heading';
import hr from './hr';
import lists from './lists';
import p from './p';
import pre from './pre';
import text from './text';

export const markdownStyles = {
    ...heading,
    ...pre,
    ...p,
    ...lists,
    ...a,
    ...hr,
    ...text,
};
